export default function getHandler(log) {
  return function handleEvent({ state, ev, data }) {
    if (!state.eventHandler) {
      log('handler not setted');
    } else {
      const fn = state.eventHandler[ev];
      if (typeof fn === 'function') fn(data);
      else {
        log(
          `no handler ${ev} ${typeof data === 'object'
            ? JSON.stringify(Object.keys(data))
            : 'no-data'}`,
        );
      }
    }
  };
}
